import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import extraReducers from './extraReducers';
import { DEFAULT_MOCKUP_GENERATION_LOGS_PARAMS } from './defaults';
import { IMockupGenerationLog, IMockupGenerationLogsQueryParams } from '../../../api/mockupGenerationLogs';

export * from '../../thunk/mockupGenerationLogs';
export { DEFAULT_MOCKUP_GENERATION_LOGS_PARAMS } from './defaults';

export interface IMockupGenerationLogsState {
    list: IMockupGenerationLog[];
    status: string | null;
    error: string | null;
    queryParams: IMockupGenerationLogsQueryParams;

    analyticsRows: IMockupGenerationLog[];
    analyticsTotal: number;
    analyticsTruncated: boolean;
    analyticsStatus: string | null;
    analyticsError: string | null;
    analyticsParams: IMockupGenerationLogsQueryParams | null;

    singleLog: IMockupGenerationLog | null;
    singleStatus: string | null;
    singleError: string | null;
}

const initialState: IMockupGenerationLogsState = {
    list: [],
    status: null,
    error: null,
    queryParams: DEFAULT_MOCKUP_GENERATION_LOGS_PARAMS(),

    analyticsRows: [],
    analyticsTotal: 0,
    analyticsTruncated: false,
    analyticsStatus: null,
    analyticsError: null,
    analyticsParams: null,

    singleLog: null,
    singleStatus: null,
    singleError: null,
};

const MockupGenerationLogsSlice = createSlice({
    name: 'mockupGenerationLogs',
    initialState,
    reducers,
    extraReducers,
});

const { actions, reducer } = MockupGenerationLogsSlice;
export const {
    clearMockupGenerationLogsFilters,
    setMockupGenerationLogsQueryParams,
    clearMockupGenerationLog,
} = actions;
export { reducer };
